import { render } from "./Absenteeism.vue?vue&type=template&id=31be8820"
import script from "./Absenteeism.vue?vue&type=script&lang=js"
export * from "./Absenteeism.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__